import React, { useState, useContext, useCallback } from "react";
import { ModuleWrapper } from "components/fragments";
import { HeaderA } from "components/headers";
import lang from "translations";
import DeviceLocationMap from "./DeviceLocationMap";
import { useApi, useFilter, useMount } from "hooks";
import { VenueContext } from "contexts";
import { mapObject } from "services";
import {
  mdmListRequest,
  mdmListResponse,
} from "mappers/mdm.mapper";
import {
  searchMdmData
} from "apis/mdm.api";
import { getVenues } from "apis";
import * as moment from "moment";

import { mdmFilterState } from "../mdm-list/filters";
const DeviceGeoLocation = () => {
  const { venue } = useContext(VenueContext);
  const [venues, setVenues] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [selectedVenueId, setSelectedVenueId] = useState(null);
  const { request: getVenuesRequest } = useApi({ api: getVenues });

  const {
    request: searchDeviceRequest,
    mappedData
  } = useApi({
    api: searchMdmData,
    isArray: true,
    handleOwnError: true,
    mapper: mdmListResponse,
  });

  const { modifyFilters } = useFilter(mdmFilterState(venue));

  // Fetch venues and set default selection based on showMdm
  useMount(async () => {
    const venueList = await getVenuesRequest();
    const mappedVenues = venueList.map(v => ({ venueId: v.venueId, venueName: v.venueName }));
    setVenues(mappedVenues);
    const showMdm = venue.showMdm?.toLowerCase();
    const startDate = moment("2022-01-01T00:00:00");
    const endDate = moment();
    if (showMdm === "self") {
      setSelectedVenueId(venue.venueId);
      // Fetch devices for self
      const { requestState } = modifyFilters({ page: 1, pageSize:2000, venueId: venue.venueId, dateRange: [startDate, endDate] });
      await searchDeviceRequest(mapObject(requestState, mdmListRequest));
    } else if (showMdm === "all" && mappedVenues.length > 0) {
      setSelectedVenueId(mappedVenues[0].venueId);
      // Fetch devices for first venue
      const { requestState } = modifyFilters({ page: 1, pageSize:2000, venueId: mappedVenues[0].venueId, dateRange: [startDate, endDate] });
      await searchDeviceRequest(mapObject(requestState, mdmListRequest));
    }
  });

  // Venue change callback
  const handleVenueChange = useCallback(async (venueId) => {
    setSelectedVenueId(venueId);
    const startDate = moment("2022-01-01T00:00:00");
    const endDate = moment();
    const { requestState } = modifyFilters({ page: 1, venueId, dateRange: [startDate, endDate] });
    await searchDeviceRequest(mapObject(requestState, mdmListRequest));
  }, [modifyFilters, searchDeviceRequest]);

  // Venue dropdown options and disabled logic
  const showMdm = venue.showMdm?.toLowerCase();
  let venueOptions = [];
  let venueDropdownDisabled = false;
  
  if (showMdm === "self") {
    venueOptions = venues.filter(v => v.venueId === venue.venueId).map(v => ({ text: v.venueName, value: v.venueId }));
    venueDropdownDisabled = true;
  } else if (showMdm === "all") {
    venueOptions = venues.map(v => ({ text: v.venueName, value: v.venueId }));
    venueDropdownDisabled = false;
  }

  // Hide everything if showMdm is null
  if (venue.showMdm === null) {
    return null;
  }

  return (
    <ModuleWrapper
      header={
        <HeaderA
          title={lang.deviceGeoLocation}
          description={lang.deviceGeoLocationDescription}
          className="mb-md"
        />
      }
    >
      <div className="w-full">
        <div className="bg-white rounded-lg shadow p-4">
          <DeviceLocationMap
            devices={mappedData}
            selectedDeviceId={selectedDevice?.id}
            onDeviceSelect={setSelectedDevice}
            venues={venueOptions}
            selectedVenueId={selectedVenueId}
            onVenueChange={handleVenueChange}
            venueDropdownDisabled={venueDropdownDisabled}
          />
        </div>
      </div>
    </ModuleWrapper>
  );
};

export default DeviceGeoLocation;
